import { Button, Card, Col, Form, Row } from 'antd';
import { useContext, useEffect, useState } from 'react';

import { AuthContext } from 'components/Auth/Auth';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import GetLabel from 'DisplayFramework/components/GetLabel';
import IBasket from 'icons/IBasket';
import IPen from 'icons/IPen';
import ModalSFS from 'components/theme_components/ModalSFS';
import { PlusOutlined } from '@ant-design/icons';
import ProductTriggerModal from './ProductModals/ProductTriggerModal';
import React from 'react';
import Title from 'components/Title';

export type ProductTriggerProps = {
  form: any;
  required: boolean;
  triggersList: any[];
  setTriggersList: (triggers: any[]) => void;
};

const ProductTrigger = ({
  form,
  required,
  triggersList,
  setTriggersList,
}: ProductTriggerProps) => {
  const [isVisible, setVisible] = useState(false);
  const [, setVisibleupdate] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [item, setItem] = useState('' as any);
  const { isInspect } = useContext(AuthContext);
  useEffect(() => {
    form.setFieldsValue({
      triggers: triggersList || [],
    });
  }, [triggersList, form]);

   // Extract existing trigger event labels from the triggersList
  const getExistingTriggerLabels = (excludeKey?: string) => {
    return (
      triggersList
        ?.filter((trigger) => trigger.key !== excludeKey) // Exclude current item when updating
        ?.map((trigger) => trigger.triggerEventLabel)
        ?.filter((label) => label) || // Remove undefined/null labels
      []
    )
  }

  const addCard = (newCard: any) => {
    const updatedData = [
      ...triggersList,
      { key: (triggersList.length + 1).toString(), ...newCard },
    ];
    setTriggersList(updatedData);
  };

  const deleteCard = (key: string) => {
    const updatedData = triggersList.filter((item: any) => item.key !== key);
    setTriggersList(updatedData);
  };

  const updateCard = (updatedCard: any) => {
    const updatedData = triggersList.map((dataItem: any) =>
      dataItem.key === updatedCard.key
        ? { ...dataItem, ...updatedCard }
        : dataItem
    );
    setTriggersList(updatedData);
    form.setFieldsValue({
      triggers: updatedData,
    });
  };

  return (
    <Form form={form}>
      <div className="container-stepper mt-4 taux productlist">
        <Title
          comcode="infoToCompletetriggers"
          level={4}
          className="ut-updateTP-title mb-7 mt-10"
        />

        <Row
          className="mb-4 px-6 text-center"
          gutter={24}
          justify="space-between"
          align="middle"
        >
          <Col span={5}>
            <GetLabel
              label="triggerEventId"
              className=" font-size-13 font-weight-600 gray-color"
            />
          </Col>
          <Col span={5}>
            <GetLabel
              label="timeDelayDays"
              className=" font-size-13 font-weight-600 gray-color"
            />
          </Col>
          <Col span={5}>
            <GetLabel
              label="triggerconsequence"
              className=" font-size-13 font-weight-600 gray-color"
            />
          </Col>
          <Col span={5}>
            <GetLabel
              label="triggerproduct"
              className=" font-size-13 font-weight-600 gray-color"
            />
          </Col>
          <Col span={4}></Col>
        </Row>

        {/* Use triggersList instead of data */}
        {(!triggersList || triggersList.length === 0) && (
          <Card
            style={{ zIndex: 100 }}
            className="no-border-radius no-border text-center mb-4 textCard"
          >
            <GetLabel
              label="emptyTriggers"
              className="font-size-13 gray-color text-center "
            />
          </Card>
        )}

        {/* Use triggersList instead of data */}
        {triggersList &&
          triggersList.map((item) => (
            <Card
              key={item.key}
              style={{ zIndex: 100 }}
              className="activity-card mb-4 text-center"
            >
              <Row gutter={10} justify="space-between" align="middle">
                <Col span={5}>{item.triggerEventLabel || '-'}</Col>
                <Col span={5}>{item.nbDays || '-'}</Col>
                <Col span={5}>{item.triggerconsequence || '-'}</Col>
                <Col span={5}>
                  {item.offerlabel
                    ? item.offerlabel
                    : item.offerIdTarget || '-'}
                </Col>
                <Col span={4} className="pl-0 pr-0">
                  <IBasket
                    color="#DD7248"
                    className="IBasket"
                    onClick={() => {
                      setModalVisible(true), setItem(item.key);
                    }}
                  />
                  <ModalSFS
                    className="color-gray"
                    width={560}
                    trigger={({ setVisible }) => (
                      <IPen
                        className="IPen"
                        onClick={() => {
                          setVisible(true), setItem(item);
                        }}
                      />
                    )}
                    title="updateTrigger"
                  >
                    <ProductTriggerModal
                      mode="update"
                      data={item}
                      setVisible={setVisibleupdate}
                      onUpdateCard={updateCard}
                      prcode={form.getFieldValue('prcode')}
                    />
                  </ModalSFS>
                </Col>
              </Row>
            </Card>
          ))}

        <Row justify="center" align="middle">
          <ModalSFS
            trigger={({ setVisible }) => (
              <Button
                className="ut-reset-btn ut-btn-no-border no-box-shadow font-weight-500"
                onClick={() => setVisible(true)}
                icon={<PlusOutlined />}
              >
                <GetLabel label="addTrigger" />
              </Button>
            )}
            title="createTrigger"
          >
            <ProductTriggerModal
              mode="create"
              data={triggersList}
              setVisible={setVisible}
              onAddCard={addCard}
              prcode={form.getFieldValue('prcode')}
              existingTriggerLabels={getExistingTriggerLabels(item.key)}
            />
          </ModalSFS>
          <ConfirmModal
            visible={modalVisible}
            status="error"
            message="Êtes-vous sûr de vouloir supprimer l'evenement  ? "
            onConfirm={() => {
              deleteCard(item);
              setModalVisible(false);
            }}
            onCancel={() => !isInspect && setModalVisible(false)}
            className="modalConfirmOrCancel"
          />
        </Row>
      </div>
    </Form>
  );
};

export default ProductTrigger;
